import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import {
    LoadingOverlayComponent,
    NavigationComponent,
    SigninComponent,
    ToastmessageComponent,
    TranslatableComponent,
    TranslationService,
    TranslationStore
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { NavigationMenuItem } from './navigation-menu';
import { GetTranslationRequest } from './usecases/translation-usecase/read-translation-request';
import { GetTranslationUseCase } from './usecases/translation-usecase/read-translation-usecase';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [ToastmessageComponent, NavigationComponent, LoadingOverlayComponent, RouterOutlet, RouterModule]
})
export class AppComponent extends TranslatableComponent {
    adminHomeUrl = '/home';
    colorOfMobileSidenav = 'lightorange';
    colorOfNavBar = 'black';
    cookieValue = '';
    downloadFileUrl = '';
    hasLogin = false;
    isRowView = false;
    isSubMenuFullScreen = true;
    loading = false;
    logoSize = '';
    logoUrl = '';
    nameOfTheSite = 'Regenero Egészségház Management';
    navigationMenu: NavigationMenuItem[] = [];
    positionL = 'PositionL';
    production = false;
    regeneroBaseUrl = '';
    title = 'Regenero Egészségház';

    constructor(
        _translateService: TranslationService,
        private _http: HttpClient,
        private _readTranslationfileUseCase: GetTranslationUseCase,
        public router: Router,
        @Inject('PRODUCTION') _production: boolean,
        @Inject('DOWNLOAD_FILE_URL') _downloadFileUrl: string,
        @Inject('REGENERO_BASE_URL') _regeneroBaseUrl: string,
        private elem: ElementRef
    ) {
        super(_translateService, _http);
        this.production = _production;
        this.downloadFileUrl = _downloadFileUrl;
        this.logoUrl = this.downloadFileUrl + '/20240626T101258865160117';
        this.logoSize = '200px';
        this.elem.nativeElement.style.setProperty('--logo-size', this.logoSize);
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    override readTranslations(http: HttpClient, language: string): Observable<TranslationStore> {
        const request: GetTranslationRequest = { url: './assets/i18n/' + language + '.json' };
        this._readTranslationfileUseCase.execute(request) as unknown as Observable<TranslationStore>;
        return this._http.get<TranslationStore>('./assets/i18n/' + language + '.json');
    }

    override onInit(): void {
        if (!sessionStorage.getItem('token')) {
            this.router.navigateByUrl('/');
        }
    }

    loadRouterOutletInput(component: SigninComponent) {
        if (component instanceof SigninComponent) {
            component.admin = true;
            component.hasCityAndZipUrl = false;
            component.redirectUrl = '/home';
        }
    }
}
